import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "med-left-aside",
  templateUrl: "./med-left-aside.component.html",
  styleUrls: ["./med-left-aside.component.scss"],
})
export class MedLeftAsideComponent {
  private _visible = true;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  get visible(): boolean {
    return this._visible;
  }

  @Input() set visible(show: boolean) {
    this._visible = show;
  }

  change(): void {
    this._visible = !this._visible;
    this.visibleChange.emit(this._visible);
  }
}
